"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'textDefault';
  var margin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [0];

  var _useTheme = (0, _useTheme2.default)(),
      spacing = _useTheme.spacing,
      colors = _useTheme.colors;

  return {
    root: {
      height: spacing(size),
      width: spacing(size),
      color: colors[color],
      margin: spacing.apply(void 0, (0, _toConsumableArray2.default)(margin))
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing, colors }}", function () {
  return [_useTheme2.default];
});

var Icon = function Icon(props, ref) {
  var Element = props.as,
      margin = props.margin,
      size = props.size,
      color = props.color,
      other = (0, _objectWithoutProperties2.default)(props, ["as", "margin", "size", "color"]);
  var classes = useStyles(size, color, margin);

  if (!Element) {
    return null;
  }

  return (0, _core.jsx)(Element, (0, _extends2.default)({
    ref: ref,
    css: classes.root
  }, other));
};

__signature__(Icon, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = (0, _react.forwardRef)(Icon);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icon/index.tsx");
  reactHotLoader.register(Icon, "Icon", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icon/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icon/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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